<div class="section-home">
    <div class="no-access-icon">
        <i class="fa-solid fa-lock"></i>
    </div>
    <h1>No Access</h1>
    <p>
        <b>We apologize for the inconvenience, but you do not have access to this page.</b>
    </p>
    <p>
        {{ message }} 
    </p>
    <div class="login-section">
      <app-auth-button></app-auth-button>
    </div>
</div>